module.exports = __webpack_public_path__ + "static/media/Logo Teroka Hitam (3).7446571e.png";